export default __webpack_public_path__ + "static/media/library.84dcaab2.svg";